import { useMemo } from 'react';
import { useEmbedConfig } from 'features/EmbedConfig';
import { RouterTypes } from 'router/types';
import { isExperienceListHome } from 'router/utils';
import { encodeRoute } from 'router/queryRouteCodec';

/**
 * Generates the appropriate href for a listing based on the router type.
 * Supports query-param, browser history, and hash routing.
 *
 * @param route - The internal route (pathname + search) to link to
 * @returns The complete href string for the route
 */
export const useListingHref = (route: {
  pathname: string;
  search: string;
}): string => {
  const embedConfig = useEmbedConfig();

  return useMemo(() => {
    const currentPath = window.location.pathname;
    const routePath = `${route.pathname}${route.search}`;

    if (embedConfig.routerType === RouterTypes.QUERY) {
      const search = encodeRoute(
        { pathname: route.pathname, search: route.search },
        window.location.search,
        { listIsHome: isExperienceListHome(embedConfig.home) },
      );
      return `${currentPath}${search}`;
    }

    if (embedConfig.routerType === RouterTypes.BROWSER) {
      return `${currentPath}${routePath}`;
    }

    return `${currentPath}#!${routePath}`;
  }, [embedConfig.routerType, embedConfig.home, route.pathname, route.search]);
};

export default useListingHref;
